export default function GS_Sort_Sheet() {
  return (
    <div className="p-4">
      <h1>GS Sort Sheet</h1>
    </div>
  );
}
